export const CookieName = "rent_mart_admin_security";
